import { Divider } from "@blueprintjs/core"
import { HasId, ID } from "src/libs/interfaces/layouts"
import { HISTORY_TYPE, IHistoryStep, ILandingSection, SECTION_DESIGN_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import CW, { ICarouselNavigation } from "./carousel-widget"
import updateHistory from "./utils/updateHistory"


/* Protopia Ecosystem component */
export interface ICarouselWidgetProps {
   sectionId: ID
}
const CarouselWidget = ({sectionId, ...props}: ICarouselWidgetProps): JSX.Element => {
    const currentLanding    = useLandingStore((state: ILandingStore) => state.currentLanding)
    const section           = currentLanding.sections.find( (section: HasId) => section.id === sectionId )  
    
 
    const onChange = ( data: ICarouselNavigation ) => {
        const prevData          = JSON.parse( JSON.stringify( section ) )
        const newSection: any   = { 
            ...section, 
            carousel_nav_position: data.carousel_nav_position,
            carousel_nav: data.carousel_nav, 
            carousel_nav_theme: data.carousel_nav_theme,
            carousel_nav_type: data.carousel_nav_type,
            carousel_nav_size: data.carousel_nav_size,
        } 
        const historyStep: IHistoryStep = {
            data:  newSection,
            prevData,
            type: HISTORY_TYPE.SECTION,
            title : "Update section's carousel navigating layout",
        }
        const newLanding = {
            ...currentLanding,
            sections: currentLanding.sections.map((sec: ILandingSection) => {
                if(sec.id === sectionId ) {
                    return newSection
                }
                return sec
            })
        }  
        updateHistory( historyStep, newLanding ) 
    }

    return [ SECTION_DESIGN_TYPE.CAROUSEL ].includes( section.designType )
        ?
        <>
            <div className="p-2"> 
                <CW 
                    carousel_nav_position={ section.carousel_nav_position }
                    carousel_nav={ section.carousel_nav }
                    carousel_nav_theme={ section.carousel_nav_theme }
                    carousel_nav_type={ section.carousel_nav_type }
                    carousel_nav_size={ section.carousel_nav_size }
                    onChange={onChange}
                /> 
            </div>  
            <Divider  />
        </>
        :
        <></>
}
export default CarouselWidget
 